// extracted by mini-css-extract-plugin
export var icon = "_4i-1";
export var subtext = "_4i-0";